// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1pEZr","productName":"Table_productName__2RNUG"};